import type { FC, ReactNode } from 'react';

import type { ContentTextProps } from '@/components/molecules/ContentText';
import { ContentText } from '@/components/molecules/ContentText';
import TemplateRenderer, {
    type TemplateRendererProps,
} from '@/components/organisms/TemplateRenderer';
import type { ItemsContainerProps } from '@/components/layout/ItemsContainer';
import { ItemsContainer } from '@/components/layout/ItemsContainer';
import type { SectionProps } from '@/components/layout/Section';
import Section from '@/components/layout/Section';

export interface ItemsContainerSectionProps extends SectionProps {
    items?: TemplateRendererProps[];
    containerConfig?: ItemsContainerProps;
    headerContentText?: ContentTextProps;
    footerNode?: ReactNode | string | (ReactNode | string)[];
}

const ItemsContainerSection: FC<ItemsContainerSectionProps> = ({
    items,
    containerConfig,
    headerContentText,
    footerNode,
    ...props
}) => (
    <Section {...props}>
        {!!headerContentText && <ContentText {...headerContentText} />}

        {!!containerConfig && (
            <ItemsContainer {...containerConfig}>
                {items?.map((item, index) =>
                    containerConfig.asList ? (
                        <li key={item.id || index}>
                            <TemplateRenderer {...item} />
                        </li>
                    ) : (
                        <TemplateRenderer
                            key={item.id || index}
                            {...item}
                        />
                    ),
                )}
            </ItemsContainer>
        )}

        {!!footerNode && footerNode}
    </Section>
);

export default ItemsContainerSection;
